module.exports = __webpack_public_path__ + "img/enhance_your_experience-eb.a4450c32.png";